/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UIToast.tsx
 */

import React from "react";
import ReactDOM from "react-dom";

const DEFAULT_ERROR_CONTAINER_ID = '#error-container';
const DEFAULT_ERROR_TIMEOUT = 5000;

export default class UIToast {
    private _container: Element;
    private _component?: JSX.Element;

    constructor(container: Element) {
        this._container = container;
    }

    public static get default() {
        const element = document.querySelector(DEFAULT_ERROR_CONTAINER_ID);
        if (!element) {
            throw new Error('Error: default alert container Id is not defined');
        }

        return new UIToast(element);
    }

    /**
     * dismiss
     */
    public dismiss = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        ReactDOM.unmountComponentAtNode(this._container);
    };

    /**
     * show
     * @param timeout Alert timeout (in ms)
     */
    public show(text: string = 'Veuillez réessayer plus tard...', timeout: number = DEFAULT_ERROR_TIMEOUT) {

        this._component = this._generateAlert(text);
        ReactDOM.render(this._component, this._container);

        setTimeout(this.dismiss, timeout);
    }

    /**
     * _generateAlert
     */
    private _generateAlert(text: string): JSX.Element {
        return <div className="notification is-success is-light">
            <button className="delete" onClick={this.dismiss}></button>
            <strong>Information</strong>
            <br/>
            {text}
        </div>
    }
}